import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { LanguageDto } from '@codegen/Vaimoo.Admin.API';
import { LocalizationService } from '@core/services/localization.service';

export const languagesResolver: ResolveFn<void> = async (route, state) => {
  const localizationService = inject(LocalizationService);

  return await localizationService.getLanguagesAsync().then((languages: LanguageDto[]) => {
    localizationService.$setlanguages(languages);
  });
};
